import React from 'react';
import { SortField, SortOrder } from '../../types/Campaign';
import { Select } from '../atoms/Select';

interface MobileSortBarProps {
  sortField: SortField;
  sortOrder: SortOrder;
  onSortFieldChange: (field: SortField) => void;
  onSortOrderChange: (order: SortOrder) => void;
}

const sortOptions = [
  { value: 'startDate-desc', label: 'Data de início (mais recente)' },
  { value: 'startDate-asc', label: 'Data de início (mais antiga)' },
  { value: 'endDate-desc', label: 'Data de fim (mais recente)' },
  { value: 'endDate-asc', label: 'Data de fim (mais antiga)' },
  { value: 'campaignTitle-asc', label: 'Título (A-Z)' },
  { value: 'campaignTitle-desc', label: 'Título (Z-A)' },
  { value: 'brandName-asc', label: 'Marca (A-Z)' },
  { value: 'brandName-desc', label: 'Marca (Z-A)' },
];

export const MobileSortBar: React.FC<MobileSortBarProps> = ({
  sortField,
  sortOrder,
  onSortFieldChange,
  onSortOrderChange,
}) => {
  const currentValue = `${sortField}-${sortOrder}`;

  const handleChange = (value: string) => {
    const [field, order] = value.split('-') as [SortField, SortOrder];
    onSortFieldChange(field);
    onSortOrderChange(order);
  };

  return (
    <div className="lg:hidden bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 p-4 mb-4">
      <Select
        options={sortOptions}
        value={currentValue}
        onChange={(e) => handleChange(e.target.value)}
      />
    </div>
  );
};
